import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  readonly #isLoading = signal(false);
  readonly #message = signal<string | null>(null);

  readonly isLoading = this.#isLoading.asReadonly();
  readonly message = this.#message.asReadonly();

  show(message?: string): void {
    this.#message.set(message ?? null);
    this.#isLoading.set(true);
  }

  hide(): void {
    this.#isLoading.set(false);
    this.#message.set(null);
  }
}
